import React from 'react';
import { Switch, Route } from 'react-router-dom';
import IndexEvents from '@pathways/pages/IndexEvents';
import { useHasPermissions } from '@authorisation/hooks';
import { Permissions } from '@authorisation/constants';
import Hospitals from './Hospitals';
// import HAHospitalDetails from './Hospital';
import HAOrganisationDetails from './CurrentOrganisation';
import Integrations from './Integrations';
import HADataRequestList from './DataRequests';
import CreateDataRequest from './DataRequests/CreateDataRequest';
import CreateDeletionRequest from './DataRequests/CreateDeletionRequest';
import DashboardUsers from './DashboardUsers';
import ConnectionCodes from './ConnectionCodes';
import Flags from './Flags';
import DirectChildOrganisationAdministrationGuard from './DirectChildOrganisationAdministrationGuard';
import AdministrationRootRedirect from './AdministrationRootRedirect';
import DirectChildOrganisationList from './DirectChildOrganisations/List';
import DirectChildOrganisationDetails from './DirectChildOrganisations/Details';
import NewDirectChildOrganisation from './DirectChildOrganisations/New';
import DirectChildOrganisationUserList from './DirectChildOrganisationUsers/List';
import NewDirectChildOrganisationUser from './DirectChildOrganisationUsers/New';
import DirectChildOrganisationUserDetails from './DirectChildOrganisationUsers/Details';
import EditDirectChildOrganisationUser from './DirectChildOrganisationUsers/Edit';
import { matchType } from '../../propTypes';

function Administration({ match }) {
  const permissions = useHasPermissions();

  return (
    <Switch>
      <Route
        exact
        path={match.path}
        render={() => (
          <AdministrationRootRedirect
            path={match.path}
            globalAdministration={Boolean(permissions[Permissions.AdministerAllHospitals])}
          />
        )}
      />
      <Route
        exact
        path={`${match.path}/child-organisations`}
        render={() => (
          <DirectChildOrganisationAdministrationGuard>
            <DirectChildOrganisationList />
          </DirectChildOrganisationAdministrationGuard>
        )}
      />
      <Route
        exact
        path={`${match.path}/child-organisations/new`}
        render={() => (
          <DirectChildOrganisationAdministrationGuard>
            <NewDirectChildOrganisation />
          </DirectChildOrganisationAdministrationGuard>
        )}
      />
      <Route
        path={`${match.path}/child-organisations/:organisationSlug`}
        render={props => (
          <DirectChildOrganisationAdministrationGuard>
            <DirectChildOrganisationDetails {...props} />
          </DirectChildOrganisationAdministrationGuard>
        )}
      />
      <Route
        exact
        path={`${match.path}/child-organisation-users`}
        render={() => (
          <DirectChildOrganisationAdministrationGuard>
            <DirectChildOrganisationUserList />
          </DirectChildOrganisationAdministrationGuard>
        )}
      />
      <Route
        exact
        path={`${match.path}/child-organisation-users/new`}
        render={() => (
          <DirectChildOrganisationAdministrationGuard>
            <NewDirectChildOrganisationUser />
          </DirectChildOrganisationAdministrationGuard>
        )}
      />
      <Route
        exact
        path={`${match.path}/child-organisation-users/:organisationSlug/:userId`}
        render={props => (
          <DirectChildOrganisationAdministrationGuard>
            <DirectChildOrganisationUserDetails {...props} />
          </DirectChildOrganisationAdministrationGuard>
        )}
      />
      <Route
        exact
        path={`${match.path}/child-organisation-users/:organisationSlug/:userId/edit`}
        render={props => (
          <DirectChildOrganisationAdministrationGuard>
            <EditDirectChildOrganisationUser {...props} />
          </DirectChildOrganisationAdministrationGuard>
        )}
      />
      <Route path={`${match.path}/flags`} component={Flags} />
      <Route path={`${match.path}/index-events`} component={IndexEvents} />
      {permissions[Permissions.ManageConnectionCodes] && [
        <Route path={`${match.path}/codes`} key="codes" component={ConnectionCodes} />,
      ]}
      {permissions[Permissions.ViewDashboardUsers] && [
        <Route
          path={`${match.path}/dashboard-users`}
          key="dashboard-users"
          component={DashboardUsers}
        />,
      ]}
      {permissions[Permissions.ViewDataRequests] && [
        <Route
          exact
          path={`${match.path}/create-data-request`}
          key="data-request"
          component={CreateDataRequest}
        />,
        <Route
          exact
          path={`${match.path}/create-deletion-request`}
          key="deletion-request"
          component={CreateDeletionRequest}
        />,
        <Route
          path={`${match.path}/data-requests`}
          key="data-requests-list"
          component={HADataRequestList}
        />,
      ]}
      {permissions[Permissions.AdministerHospital] && [
        <Route path={`${match.path}/integrations`} key="integrations" component={Integrations} />,
      ]}
      {permissions[Permissions.AdministerHospital] && [
        <Route
          path={`${match.path}/organisation`}
          key="currentOrg"
          component={HAOrganisationDetails}
        />,
      ]}
      {permissions[Permissions.AdministerAllHospitals] && (
        <Route path={`${match.path}/organisations`} component={Hospitals} />
      )}
    </Switch>
  );
}

Administration.propTypes = {
  match: matchType.isRequired,
};

export default Administration;
